module.exports = __webpack_public_path__ + "img/goumaiqudao.05226b6c.png";